import CreateEntityScroll from "@/domains/createEntity/components/CreateEntityScroll";
import CreateEntityTitle from "@/domains/createEntity/components/CreateEntityTitle";

type Props = {
  onClose?: () => void;
};

export default function CrateEntityBusinessFormContainer({ onClose }: Props) {
  return (
    <>
      <CreateEntityTitle title="Бизнес" onClose={onClose} />
      <CreateEntityScroll>
        <div className="flex flex-col gap-3.5">coming soon...</div>
      </CreateEntityScroll>
    </>
  );
}
